// newsCategories.ts
import {
  Gavel,
  Rule,
  Policy,
  School,
  Quiz,
  Assignment,
  FactCheck,
  MenuBook,
  Security,
  ReportProblem,
  WarningAmber,
  HealthAndSafety,
  BuildCircle,
  Engineering,
  CarRepair,
  DirectionsCar,
  ElectricCar,
  LocalGasStation,
  PrecisionManufacturing,
  EventNote,
  CalendarMonth,
  AccessTime,
  Notifications,
  Event,
  Group,
  Celebration,
  AttachMoney,
  Savings,
  RequestQuote,
  Article,
  Lightbulb,
  TipsAndUpdates,
  AutoStories,
  AccountBalance,
  Balance,
  HowToReg,
} from "@mui/icons-material";

export const newsCategories = [
  { id: "Gavel", label: "Изменения в ПДД", icon: Gavel },
  { id: "Rule", label: "Правила и нормы", icon: Rule },
  { id: "Policy", label: "Политика и регламенты", icon: Policy },
  { id: "School", label: "Обучение и экзамены", icon: School },
  { id: "Quiz", label: "Тестирование", icon: Quiz },
  { id: "Assignment", label: "Практика", icon: Assignment },
  { id: "FactCheck", label: "Проверка знаний", icon: FactCheck },
  { id: "MenuBook", label: "Учебные материалы", icon: MenuBook },
  { id: "Security", label: "Безопасность", icon: Security },
  { id: "ReportProblem", label: "Проблемные ситуации", icon: ReportProblem },
  { id: "WarningAmber", label: "Предупреждения", icon: WarningAmber },
  {
    id: "HealthAndSafety",
    label: "Здоровье и безопасность",
    icon: HealthAndSafety,
  },
  { id: "BuildCircle", label: "Техническое состояние", icon: BuildCircle },
  { id: "Engineering", label: "Инженерия", icon: Engineering },
  { id: "CarRepair", label: "Ремонт и уход", icon: CarRepair },
  { id: "DirectionsCar", label: "Автоновости", icon: DirectionsCar },
  { id: "ElectricCar", label: "Электромобили", icon: ElectricCar },
  { id: "LocalGasStation", label: "Топливо", icon: LocalGasStation },
  {
    id: "PrecisionManufacturing",
    label: "Автопром",
    icon: PrecisionManufacturing,
  },
  { id: "EventNote", label: "Расписание", icon: EventNote },
  { id: "CalendarMonth", label: "Календарь", icon: CalendarMonth },
  { id: "AccessTime", label: "Время", icon: AccessTime },
  { id: "Notifications", label: "Уведомления", icon: Notifications },
  { id: "Event", label: "Мероприятия", icon: Event },
  { id: "Group", label: "Группы и классы", icon: Group },
  { id: "Celebration", label: "Праздники и достижения", icon: Celebration },
  { id: "AttachMoney", label: "Оплата", icon: AttachMoney },
  { id: "Savings", label: "Скидки", icon: Savings },
  { id: "RequestQuote", label: "Расчёт стоимости", icon: RequestQuote },
  { id: "Article", label: "Статьи", icon: Article },
  { id: "Lightbulb", label: "Советы", icon: Lightbulb },
  { id: "TipsAndUpdates", label: "Обновления", icon: TipsAndUpdates },
  { id: "AutoStories", label: "Истории водителей", icon: AutoStories },
  { id: "AccountBalance", label: "Законодательство", icon: AccountBalance },
  { id: "Balance", label: "Справедливость и правила", icon: Balance },
  { id: "HowToReg", label: "Госрегистрация", icon: HowToReg },
];
